/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Button, DataGrid, Grid, Input, Modal, Table, Title} from '../../../components/index';
import User from "../../../domain/User";
import { regrasDeCalculo } from "../../../utils/listsSelect";
import Masks from "../../../utils/masks";
import { formatarCnpj } from '../../../utils/helpers';

const linhasPorPagina = 8;
const acao = { MARCAR: 'marcar', DESMARCAR: 'desmacar' };
const avisoVinculosConcomitantes = {
  padding: '10px',
  color: 'rgb(84, 110, 122)'
}

function Vinculo(props) {
  const titulo = (r) => {
    const inicioPeriodo = ` | ${r.dataInicio}`;
    const fimPeriodo = r.dataFim ? ` - ${r.dataFim}` : '';
    const tipoRelacaoPrevi = r.tipoRelacaoPrevidenciaria ? `Filiação: ${r.tipoRelacaoPrevidenciaria}` : '';
    const cnpj = r.cnpj ? ` | CNPJ: ${formatarCnpj(r.cnpj)}` : '';
    const nome = r.nome ? ` | ${r.nome}` : '';
    return `${tipoRelacaoPrevi}${cnpj}${nome}${inicioPeriodo}${fimPeriodo}`;
  }

  const relacaoPrevidenciaria = props.relacaoPrevidenciaria;

  return (
      <React.Fragment>
        <li>
          <Title title={titulo(relacaoPrevidenciaria)} type="section" fontWeight="regular-16" />
          {relacaoPrevidenciaria.regimePrevidenciario.map(e =>
            <Regime
              regime={e}
              visualizaRegime={props.visualizaRegime}
              marcarRegime={props.marcarRegime}
              desmarcarRegime={props.desmarcarRegime}
              acao={props.acao}
              tamanhoLista={props.tamanhoLista}
            />
          )}
        </li>
      </React.Fragment>
  );
}

function Regime(props) {
  const titulo = (r) => {
    const dataInicio = `${r.dataInicio}`;
    const dataFim = r.dataFim ? ` - ${r.dataFim}` : '';
    const tipoRegime = r.tipoRegimePrevidenciario ? ` - ${r.tipoRegimePrevidenciario}` : '';
    return `${dataInicio}${dataFim}${tipoRegime}`;
  }

  // Marca o vinculo informado e todos os compativeis. Desmarca todos os demais vinculos que colidam.
  const toggleRegime = (regime, acaoToggle) => {
    if (acaoToggle === acao.DESMARCAR) {
      props.desmarcarRegime(regime);
    } else {
      props.marcarRegime(regime);
    }
  }

  const checked = props.regime.tipoConcomitanteDescartado === 0
      || props.regime.tipoConcomitanteDescartado === null
      || props.regime.tipoConcomitanteDescartado === undefined;
  const acaoAoClicar = checked ? acao.DESMARCAR : acao.MARCAR;

  // 8) Deferido; 11) Em Compensação; 12) Compensado
  const exibeCheckbox = User.logged().isRPPS() && ![8, 11, 12].includes(props.estado);

  return (
      <li>
        {exibeCheckbox &&
        <input
            key={`vinculo-${props.key}-checkbox`}
            type="checkbox"
            checked={checked}
            onClick={() => toggleRegime(props.regime, acaoAoClicar)}
            style={{ transform: 'scale(1.5)', position: 'relative', top: '5px' }}
            disabled={props.acao === 'consulta' || props.tamanhoLista === 1}
        />}
        <Button
            hint={props.regime.tipoRegimePrevidenciario}
            icon="ico-money"
            mini
            onClick={() => props.visualizaRegime(props.regime)}
        />
        <span>{titulo(props.regime)}</span>
      </li>
  );
}

class DadosRelacoesPrevidenciarias extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    regime: null,
    showModal: false,
  })

  componentDidMount() {
  }

  visualizaRegime = (regime) => {
    this.setState({
      regime,
      showModal: !this.state.showModal,
    });
  }

  algumVinculoSelecionado = () => {
    const tiposConcomitantes = this.props.relacoesPrevidenciarias.map(e => e.regimePrevidenciario)
        .flat()
        .map(e => e.tipoConcomitanteDescartado);

    return tiposConcomitantes.includes(0);
  }

  verificaVinculosConcomitantes = () => {
   const resultado = this.props.validacaoConcomitancia();
   return resultado.existeConcomitancia;
  }

  createActionColumn = (indice, regime) => (
    <Button
      hint="Visualizar remunerações"
      icon="ico-money"
      mini
      onClick={() => this.visualizaRegime(indice, regime)}
    />
  )

  montaRegimesTableHeader = () => {
    return [
      { id: 'competencia0', label: 'Competência' },
      { id: 'valor0', label: 'Valor' },
      { id: 'competencia1', label: 'Competência' },
      { id: 'valor1', label: 'Valor' },
      { id: 'competencia2', label: 'Competência' },
      { id: 'valor2', label: 'Valor' }
    ];
  }

  handleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  montaListaRemuneracoes = () => {
    const colunasPorPagina = 3;
    let pagina = 0;
    let linha = 0;
    let coluna = 0;
    const listaFormatada = [];
    listaFormatada[0] = {};
    if (this.state.regime.remuneracoes === undefined) {
      listaFormatada.length = 0;
    } else {
      this.state.regime.remuneracoes.forEach((remuneracao, index) => {
        listaFormatada[linha][`competencia${coluna}`] =
          `${(`0${remuneracao.mes}`).slice(-2)}/${remuneracao.ano}`;
        listaFormatada[linha][`valor${coluna}`] = remuneracao.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
        if ((index + 1) % linhasPorPagina === 0) {
          if ((index + 1) % (linhasPorPagina * colunasPorPagina) === 0) {
            pagina += 1;
            linha = pagina * linhasPorPagina;
            coluna = 0;
            if (listaFormatada[linha] === undefined) {
              listaFormatada[linha] = {};
            }
          } else {
            linha = pagina * linhasPorPagina;
            coluna += 1;
            if (coluna % colunasPorPagina === 0) {
              coluna = 0;
            }
          }
        } else {
          linha += 1;
          if (listaFormatada[linha] === undefined) {
            listaFormatada[linha] = {};
          }
        }
      });
    }

    return listaFormatada;
  }

  options = {
    noDataText: 'Não existe remuneração para o período selecionado.',
    hideSizePerPage: true,
    sizePerPage: linhasPorPagina,
  }

  montaModalContent = () => (
    <React.Fragment>
      <div className="row" style={{ height: '350px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }}>
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled
              label="Tipo de regime previdenciário"
              value={this.state.regime.tipoRegimePrevidenciario}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled
              label="Data de início do regime"
              value={this.state.regime.dataInicio}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled
              label="Data de fim do regime"
              value={this.state.regime.dataFim}
            />
          </Grid>
        </div>
        <div className="row">
          <Table
            bordered
            className="tabela-remuneracoes-regime"
            data={this.montaListaRemuneracoes()}
            options={this.options}
            listaTableHeader={this.montaRegimesTableHeader()}
            pagination
            scrollTop="Top"
          />
        </div>
      </div>
    </React.Fragment>
  );

  modalFooter = (
    <div className="right">
      <Button
        hint="Fechar"
        onClick={this.handleModal}
        title="Fechar"
      />
    </div>
  )

  render() {
    let modal;
    let complemento;
    if ((!User.logged().isRGPS()) && (this.props.estadoDoFormulario.requerimento.estado === 8 && this.verificaVinculosConcomitantes())) {
        complemento = <h4 style={avisoVinculosConcomitantes}>Vínculos concomitantes encontrados.</h4>   
    } 
    if (this.state.showModal) {
      modal = (
        <React.Fragment>
          <Grid cols="12 12 12 12" style={{ height: '400px', overflow: 'auto' }}>
            <Modal
              {...this.props}
              conteudomodal={this.montaModalContent()}
              conteudofooter={this.modalFooter}
              onHide={this.handleModal}
              showTitle
              size="lg"
              title="Detalhes do regime selecionado"
              showModal
            />
          </Grid>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <DataGrid title="Dados de Benefício" icon="ico-money" >
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                  disabled
                  mask={Masks.date}
                  label="Data de ingresso no regime de origem"
                  value={this.props.estadoDoFormulario.requerimento.dataIngresso}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                  disabled
                  mask={Masks.date}
                  label="Data de desvinculação no regime de origem"
                  value={this.props.estadoDoFormulario.requerimento.dataDesvinculacao}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              { !this.props.rgpsEnvolvido &&
              <Input
                  disabled
                  label="Regra de Cálculo"
                  itemList={regrasDeCalculo}
                  value={this.props.estadoDoFormulario.requerimento.regraDeCalculo}
              /> }
            </Grid>
          </div>
        </DataGrid>

        <ol>
          {this.props.relacoesPrevidenciarias.map((rel, index) =>
            <Vinculo
              key={`vinculo-${index}`}
              relacaoPrevidenciaria={rel}
              vinculosSelecionados={this.state.vinculosSelecionados}
              visualizaRegime={this.visualizaRegime}
              marcarRegime={this.props.marcarRegime}
              desmarcarRegime={this.props.desmarcarRegime}
              acao={this.props.acao}
              tamanhoLista={this.props.relacoesPrevidenciarias.length}
            />
          )}
        </ol>
        {modal}
        {!User.logged().isRGPS() &&
          this.props.relacoesPrevidenciarias.map(e => e.regimePrevidenciario).flat().length > 1 &&
          this.props.acao !== 'consulta' &&
        <Button
            hint="Confirmar Seleção"
            title={this.props.confirmado ? "Confirmado" : "Confirmar Seleção"}
            onClick={() => this.props.confirmar()}
            disabled={this.props.confirmado || !this.algumVinculoSelecionado() || this.verificaVinculosConcomitantes()}
        />}
        <div className="row">
          <Grid cols="12 12 12 12">
            { complemento }
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

DadosRelacoesPrevidenciarias.propTypes = {
  relacoesPrevidenciarias: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DadosRelacoesPrevidenciarias;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/DadosRelacoesPrevidenciarias.jsx